define(function(require, exports, module) {
    'use strict';
    const { split } = require('ramda');

    const parseDtagStringToArray = split(',');

    module.exports = parseDtagStringToArray;
});